import BoardTextBody from '../board-text-body/BoardTextBody';
import { POST_BODY_COMPOSITION } from '../board-text-body/composition';

export default function PostBodyComposer(props) {
  return <BoardTextBody {...props} composition={POST_BODY_COMPOSITION} />;
}
